(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcb-cashback"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var DCB_CONFIG = { cookieName: 'decko_ref', cookieDays: 30, cartAttributeKey: 'Referred by', cartUpdateUrl: '/cart/update.js' };
  window.DCB = window.DCB || {};

  DCB.initFAQ = function () {
    var items = document.querySelectorAll('.dcb-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var question = item.querySelector('.dcb-faq__q');
      if (!question) return;
      if (question.dataset.dcbBound === '1') return;
      question.dataset.dcbBound = '1';
      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) { other.classList.remove('is-open'); });
        if (!isOpen) {
          item.classList.add('is-open');
          question.setAttribute('aria-expanded', 'true');
        } else {
          question.setAttribute('aria-expanded', 'false');
        }
      });
    });
  };

  DCB.trackReferrer = function () {
    var params = new URLSearchParams(window.location.search);
    var refId = params.get('ref');
    if (refId && /^[a-zA-Z0-9_-]+$/.test(refId)) {
      DCB._setCookie(DCB_CONFIG.cookieName, refId, DCB_CONFIG.cookieDays);
    }
  };

  DCB._setCookie = function (name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  };

  DCB._getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  };

  DCB.attachToCart = function () {
    var refId = DCB._getCookie(DCB_CONFIG.cookieName);
    if (!refId) return;
    var payload = { attributes: {} };
    payload.attributes[DCB_CONFIG.cartAttributeKey] = refId;
    fetch(DCB_CONFIG.cartUpdateUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(function () {});
  };

  function dcbInit() {
    DCB.trackReferrer();
    DCB.attachToCart();
    DCB.initFAQ();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dcbInit);
  } else {
    dcbInit();
  }
  document.addEventListener('shopify:section:load', DCB.initFAQ);
})();

  } catch(e) { console.error(e); }
})();
})();
